/**
 * Utility function to get proxied URL for images
 * Only applies proxy for non-HTTPS URLs
 * @param {string} url - The original image URL
 * @returns {string} - The proxied URL or original URL
 */
export function getProxiedUrl(url) {
  if (!url) return '';
  
  // If URL is already HTTPS, return as is
  if (url.startsWith('https://')) {
    return url;
  }
  
  // If URL is HTTP or doesn't start with http/https, apply proxy
  if (url.startsWith('http://') || !url.startsWith('http')) {
    return `https://images.weserv.nl/?url=${encodeURIComponent(url)}`;
  }
  
  return url;
}

/**
 * Utility function to get the first image from an array with proxy support
 * @param {Array} images - Array of image URLs
 * @returns {string} - The first image URL with proxy if needed
 */
export function getFirstImage(images) {
  if (!images || !Array.isArray(images) || images.length === 0) {
    return '';
  }
  return getProxiedUrl(images[0]);
} 